import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
	root: {
		display: "flex",
		minWidth: "100vw",
		minHeight: "100vh",
		alignItems: "center",
		justifyContent: "center",
	},
	formContainer: {
		width: 420,
		height: "100%",
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		paddingInline: 34,
	},

	loginButton: {
		borderRadius: theme.shape.borderRadiusPill,
		padding: "8px 16px",
		border: `1px solid ${theme.palette.divider}`,
		height: 50,
		width: "30ch",
		textTransform: "none",
		color: theme.palette.text.primary,
		background: "none",
		display: "flex",
		gap: "12px",
		whiteSpace: "nowrap",
		fontSize: "1rem",
		fontWeight: "bold",
		"&:focus": {
			outline: "none",
		},
	},
	form: {
		width: "100%",
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		padding: "16px",
		marginBottom: "12px",
		gap: "16px",
	},
	formHeader: {
		fontSize: "20px",
		margin: "30px 0",
		color: theme.palette.text.primary,
	},
	formInput: {
		background: "#F5F5F5",
		appearance: "none",
		border: "none",
		width: "100%",
		marginLeft: 12,
		"&:focus": {
			outline: "none",
		},
	},
	forgotPassword: {
		letterSpacing: 0,
		fontSize: "12px",
		width: "100%",
		display: "flex",
		justifyContent: "center",
		"& > a": {
			cursor: "pointer",
			width: "fit-content",
			color: theme.palette.text.primary,
			fontWeight: "bold",
			textDecoration: "underline",
			fontSize: 16,
		},
	},
	boldText: {
		fontWeight: "bold",
		cursor: "pointer",
	},
	microsoftLogo: {
		height: "24px",
		maxWidth: "24px",
	},
}));
